import { createContext } from 'react';
// Create context with default values
export var CopilotContext = createContext(null);
//# sourceMappingURL=context.js.map